export const convertCentsToEuros = (cents: number, nbDecimalsToFix = 4): number => {
    const euros = cents / 100;
    return Number.parseFloat(euros.toFixed(nbDecimalsToFix));
}

export const convertEurosToCents = (euros: number): number => {
    const cents = euros * 100;
    return Number.parseFloat(cents.toFixed(2));
}
